/**
 * @fileoverview Module for `src/dashboard/manage-letters/SocialBundleInfo.js`.
 */

import PropTypes from 'prop-types';
import SocialSendEmail from './SocialSendEmail';

SocialBundleInfo.propTypes = {
  bundle: PropTypes.object.isRequired,
  myLettersMessage: PropTypes.string.isRequired,
};

/**
 * Shows social bundle ownership details or reminder email controls.
 *
 * @param {Object} params
 * @returns {JSX.Element} Social bundle helper message.
 */
export default function SocialBundleInfo({ bundle, myLettersMessage }) {
  return (
    <div className='row' >
      <label className='letter-info' >
        {
          bundle.social_assignee_email === bundle.email
            ? (
              <span className='text-gray'>{ myLettersMessage }</span>
              )
            : (<SocialSendEmail bundle={ bundle } />)
        }
      </label>
    </div>
  );
}
